import axios from 'axios';
import moment from 'moment'

// Carto axios
const contractorPermitAxios = axios.create({
    // baseURL: "https://services.arcgis.com/fLeGjb7u4uXqeF9q/ArcGIS/rest/services/ContractorLookupApplicationEclipse/FeatureServer/0"
    baseURL: "https://services.arcgis.com/fLeGjb7u4uXqeF9q/arcgis/rest/services/AGO_Lyr_Contractor_Lookup_Application_Eclipse/FeatureServer/0"
  });

// Carto axios
const cartoAxios = axios.create({
    baseURL: process.env.VUE_APP_CARTO_ROOT
  });
  

const permitsQuery = function(acctNumber){
return `SELECT * FROM PERMITS WHERE permitnumber IN ('${acctNumber}') ORDER BY permittype`; 
}// I used the IN sentence because there could be multiple address key separated by comma (,)

const queryUrl = function( input ){
    let url =
      encodeURI("query?where=permitnumber = ") +
      encodeURI("'") +
      encodeURIComponent(input) +
      encodeURI("'") +
      encodeURI("OR contractorname like'%") +
      encodeURIComponent(input) +
    //   encodeURI("%'&outFields=*&orderByFields=issuedate+desc&resultOffset=0&returnGeometry=false&resultRecordCount=500&sqlFormat=none&f=pjson");
      encodeURI("%'&outFields=*&orderByFields=issuedate+desc&resultOffset=0&returnGeometry=false&sqlFormat=none&f=pjson");
    // Build the queryUrl from the queryParams
    // for (let key in params) {
    //   const queryParam = "&" + key + "=" + this.queryParams[key];
    //   url += queryParam;
    // }
    return url;
  };


const state = () => ({
    contractorPermits: {},
    contractorNames: [],
    permitStatus: [],
    permitTypes: [],
});

// const getters = {
// };

const mutations = {
    setContractorPermits(state, data) {
        // console.log("mutation for permits: ", data)
        let dataArray = [];
        if (data) {
            Object.values(data).forEach((x => 
                dataArray.push(x.attributes)
                ));
                // console.log("dataArray: ", dataArray)
            dataArray.forEach( a => a.ISSUEDATE = moment(a.ISSUEDATE).isValid() ? a.ISSUEDATE : "Not Available");
            state.permitTypes = [...new Set(dataArray.map(item => item.PERMITTYPE))]; 
            state.permitStatus = [...new Set(dataArray.map(item => item.STATUS))]; 
            state.contractorNames = [...new Set(dataArray.map(item => item.CONTRACTORNAME))]; 
            return state.contractorPermits = dataArray;
        } else {
            return state.contractorPermits = null;
        }
    },
    setPermitDetails(state, data) {
        return state.permitDetails = data.data.rows;
    },
    setPermitStatus(state, data) {
        state.permitStatus = data;
    },
    setPermitTypes(state, data) {
        state.permitTypes = data;
    },
};  

const actions = {

    async getPermitsDetails({ commit, dispatch }, params) {
        dispatch;
        try {
            // console.log("getPermitsDetails: ", params);
            let response = await cartoAxios.get('/',{ params: {q: permitsQuery(params) }});
            commit('setPermitDetails', response);
            return response
        } catch (err) {
            throw new Error(err)
        } 
    },
    async getContractorPermits({ commit, dispatch }, params) {
        dispatch;
        // console.log("getContractorPermits: ", params);
        let query = queryUrl(params);
        try {
            // console.log("getContractorPermits: ", query);
            let response = await contractorPermitAxios.get(query);
            commit('setContractorPermits', { ...response.data.features });
            // console.log("Permits response: ", response.data.features)
            let permitArray = []; 
            response.data.features.forEach( a => permitArray.push("'"+a.attributes.PERMITNUMBER+"'"))
        } catch (err) {
            throw new Error(err)
        } 
      },

};




export default {
    namespaced: true,
    state,
    // getters,
    mutations,
    actions,
  };